.<template>
  <section class="mb-3">
    <div class="row">
      <div class="col-sm-12 col-12 col-md-4 col-lg-4  mb-0 mb-md-3">
        <div class="row">
          <div class="col-6 col-sm-6 col-md-12 col-lg-6 col-lg-6 mb-2 simple">
            <single-value
              :name="$t('message.dashboard.admin.vacancyRate')"
              :value="vacancyRate"
              :info-tooltip-text="$t('message.dashboard.admin.vacancyRateTooltip')"
              class="card-color cursor-pointer"
              design="blue"
              @click="$router.push({name: 'AccountingRentalObjectOverview', query: {'object[refinementList][status][0]': 'vacant', 'object[refinementList][status][1]': 'undefined', 'object[refinementList][status][2]': 'not_activated', 'predefined': 'true'}})"
              @click-middle="vacancyRateMiddle" />
          </div>
          <div class="col-6 col-sm-6 col-md-12 col-lg-6 mb-2 simple">
            <single-value
              :name="$t('message.dashboard.admin.properties')"
              :value="countProperties"
              class="card-color cursor-pointer"
              design="deep-orange"
              @click="$router.push({name: 'AccountingPropertyView'})"
              @click-middle="propertiesMiddle" />
          </div>
          <div class="col-6 col-sm-6 col-md-12 col-lg-6 mb-2 simple">
            <single-value
              :name="$t('message.dashboard.admin.buildings')"
              :value="countBuildings"
              class="cursor-pointer"
              design="gray"
              @click="$router.push({name: 'AccountingBuildingsView'})"
              @click-middle="buildingsMiddle" />
          </div>
          <div class="col-6 col-sm-6 col-md-12 col-lg-6 mb-2 simple">
            <single-value
              :name="$t('message.dashboard.admin.newMessages')"
              :value="numberMessage"
              class="cursor-pointer"
              design="gray"
              @click="$router.push({name: 'AccountingMessagesView'})"
              @click-middle="newMessagesMiddle" />
          </div>
          <div class="col-6 col-sm-6 col-md-12 col-lg-6 mb-2 simple">
            <single-value
              :name="$t('message.dashboard.marketing.eventsToday')"
              :value="countEventsToday"
              class="cursor-pointer"
              design="blue"
              @click="$router.push({name: 'AccountingCalendarOverview', params: { viewCalendar: 'day' }})"
              @click-middle="eventsTodayMiddle" />
          </div>
          <div class="col-6 col-sm-6 col-md-12 col-lg-6 mb-2 simple">
            <single-value
              :name="$t('message.dashboard.marketing.eventsThisWeek')"
              :value="countEventCurrentWeek"
              class="cursor-pointer"
              design="light-blue"
              @click="$router.push({name: 'AccountingCalendarOverview', params: { viewCalendar: 'week' }})"
              @click-middle="eventsThisWeekMiddle" />
          </div>
        </div>
      </div>
      <div class="d-none d-md-block col-sm-12 col-md-8 col-lg-8 mb-0 mb-md-3">
        <ticket-statistics-table
          v-if="isTicketingEnabled" />
        <all-object-table
          v-else
          :statistics="statistics" />
      </div>
    </div>
    <dashboard-tables-responsive
      v-if="mobileView"
      @event-today-length="getCountEventsToday"
      @event-current-Week-length="getCountEventCurrentWeek" />
    <dashboard-tables
      v-else
      @event-today-length="getCountEventsToday"
      @event-current-Week-length="getCountEventCurrentWeek" />
  </section>
</template>

<script>
import ObjectApi from '@/misc/apis/ObjectApi'
import { user } from '@/mixins/user'
import { responsivity } from '@/mixins/responsivity'
import { mail } from '@/mixins/mail'
import { chartColors } from '@/mixins/chartColors'
import { calendar } from '@/mixins/calendar'
import DashboardTables from '@/dashboard/marketing/DashboardTables'
import { mapActions, mapGetters } from 'vuex'
import SingleValue from '@/dashboard/charts/SingleValue'
import TicketStatisticsTable from '@/dashboard/TicketStatisticsTable.vue'
import AllObjectTable from '@/dashboard/admin/AllObjectTable.vue'
import DashboardTablesResponsive from '@/dashboard/marketing/DashboardTablesResponsive.vue'

export default {
  name: 'AccountingDashboardOverviewView',
  components: { DashboardTablesResponsive, AllObjectTable, TicketStatisticsTable, SingleValue, DashboardTables },
  mixins: [chartColors, user, calendar, mail, responsivity],
  metaInfo() {
    return {
      title: this.$t('message.navigation.dashboard.title')
    }
  },
  data() {
    return {
      countEventCurrentWeek: 0,
      countEventsToday: 0,
      countProperties: 0,
      countBuildings: 0,
      getNumberInterval: null,
      statistics: null
    }
  },
  computed: {
    ...mapGetters('message', ['getMailboxesForUserId']),
    mailboxesForCurrentUser() {
      return this.getMailboxesForUserId(this.userId)
    },
    vacancyRate() {
      if (this.statistics) {
        return this.statistics.vacancyRate.toFixed(2) + ' %'
      } else {
        return 'n/a'
      }
    }
  },
  watch: {
    mailboxesForCurrentUser: function () {
      this.countUnreadMails(true)
    }
  },
  mounted() {
    ObjectApi.getPropertyCount(this.$store.getters['user/getAccountId'], 'ACCOUNTING_SCOPE')
      .then(response => {
        this.countProperties = response.count
      })
    ObjectApi.getBuildingCount(this.$store.getters['user/getAccountId'], 'ACCOUNTING_SCOPE')
      .then(response => {
        this.countBuildings = response.count
      })
    ObjectApi.getObjectAccountingStatistics(this.$store.getters['user/getAccountId'])
      .then(response => {
        this.statistics = response
      })
    this.countUnreadMails()
  },
  methods: {
    ...mapActions('message', ['loadMailboxesForUserId']),
    getCountEventsToday(item) {
      this.countEventsToday = item
    },
    vacancyRateMiddle() {
      const routeData = this.$router.resolve({ name: 'AccountingRentalObjectOverview', query: { 'object[refinementList][status][0]': 'vacant', 'object[refinementList][status][1]': 'undefined', 'object[refinementList][status][2]': 'not_activated', predefined: 'true' } })
      window.open(routeData.href, '_blank')
    },
    propertiesMiddle() {
      const routeData = this.$router.resolve({ name: 'AccountingPropertyView' })
      window.open(routeData.href, '_blank')
    },
    buildingsMiddle() {
      const routeData = this.$router.resolve({ name: 'AccountingBuildingsView' })
      window.open(routeData.href, '_blank')
    },
    newMessagesMiddle() {
      const routeData = this.$router.resolve({ name: 'AccountingMessagesView' })
      window.open(routeData.href, '_blank')
    },
    eventsTodayMiddle() {
      const routeData = this.$router.resolve({ name: 'AccountingCalendarOverview', params: { viewCalendar: 'day' } })
      window.open(routeData.href, '_blank')
    },
    eventsThisWeekMiddle() {
      const routeData = this.$router.resolve({ name: 'AccountingCalendarOverview', params: { viewCalendar: 'week' } })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
